(function () {
  var SUB_KEY = 'sl_plus_subscribed';
  var SESSION_DISMISS_KEY = 'sl_plus_dismissed';
  var SUBMIT_KEY = 'sl_plus_submitting';

  function sGet(store, key) { try { return store.getItem(key); } catch (e) { return null; } }
  function sSet(store, key, val) { try { store.setItem(key, val); } catch (e) {} }
  function sRemove(store, key) { try { store.removeItem(key); } catch (e) {} }

  // Drop legacy 30-day suppress so returning visitors get the new buy-click behaviour
  sRemove(localStorage, 'sl_plus_dismissed_at');
  sRemove(sessionStorage, 'sl_plus_shown');

  // Kill Shopify's #contact_form jump as early as possible after signup posts
  if (/(?:\?|&)customer_posted=true/.test(window.location.search)) {
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    if (window.location.hash) {
      history.replaceState({}, '', window.location.pathname + window.location.search);
    }
    window.scrollTo(0, 0);
  }

  var ARROW_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48" width="72" height="72" focusable="false" aria-hidden="true">' +
    '<path fill="#9900FF" d="M13.4 39.2L41.2 9.6L37.6 5.8L10.2 35.2V5.8H4.8v33.4V45h5.4H24h15.4v-5.8H13.4z"/>' +
    '</svg>';

  // Shopify's /account/subscribe confirm page: swap shop-name heading for purple arrow
  function enhanceEmailConfirmPage() {
    var box = document.querySelector('.shopify-email-marketing-confirmation__container');
    if (!box || box.getAttribute('data-sl-plus-enhanced') === '1') return;
    box.setAttribute('data-sl-plus-enhanced', '1');

    if (!box.querySelector('.sl-plus-confirm-mark')) {
      var mark = document.createElement('div');
      mark.className = 'sl-plus-confirm-mark';
      mark.setAttribute('aria-hidden', 'true');
      mark.innerHTML = ARROW_SVG;
      box.insertBefore(mark, box.firstChild);
    }

    var heading = box.querySelector('h1');
    if (heading) {
      var raw = (heading.textContent || '').trim();
      if (/^squarelocator\+?$/i.test(raw) || raw === '') {
        heading.textContent = "You're in";
      } else {
        heading.textContent = raw.replace(/squarelocator\+?/gi, '').replace(/\s{2,}/g, ' ').trim() || "You're in";
      }
    }

    var paragraphs = Array.prototype.slice.call(box.querySelectorAll('p'));
    paragraphs.forEach(function (p) {
      if (/squarelocator/i.test(p.textContent || '') && !p.querySelector('a')) {
        p.textContent = (p.textContent || '')
          .replace(/squarelocator\+?/gi, '')
          .replace(/\s{2,}/g, ' ')
          .replace(/\s+([.,!?])/g, '$1')
          .trim();
      }
    });

    // Keep thank-you + unsubscribe on one line
    var thankYou = null;
    var unsubLine = null;
    paragraphs.forEach(function (p) {
      var text = (p.textContent || '').trim();
      if (/thank you for subscribing/i.test(text)) thankYou = p;
      if (/unsubscribe at any time/i.test(text) && !p.querySelector('a')) unsubLine = p;
    });
    if (thankYou && unsubLine && thankYou !== unsubLine) {
      var thankText = (thankYou.textContent || '').trim().replace(/\.?\s*$/, '.');
      var unsubText = (unsubLine.textContent || '').trim().replace(/^\s*/, '');
      thankYou.textContent = thankText + ' ' + unsubText;
      unsubLine.remove();
    }

    box.querySelectorAll('p').forEach(function (p) {
      if (p.querySelector('a')) {
        p.style.textAlign = 'center';
        p.style.width = '100%';
      }
    });
  }

  function placeInlineSignup() {
    var inline = document.getElementById('SlPlusInline');
    if (!inline) return;

    // Extension pages render the block statically at the end
    if (inline.classList.contains('sl-plus-inline--static')) {
      inline.hidden = false;
      return;
    }

    var rte = document.querySelector('.article-template .article-template-content__rte.rte');
    if (rte) rte.appendChild(inline);
    inline.hidden = false;
  }

  document.addEventListener('DOMContentLoaded', function () {
    placeInlineSignup();
    enhanceEmailConfirmPage();

    var popup = document.getElementById('SlPlusPopup');
    var toast = document.getElementById('SlPlusToast');

    // Follow-up after a form post (page reloads with ?customer_posted=true)
    var posted = /(?:\?|&)customer_posted=true/.test(window.location.search);
    var wasSubmitting = sGet(sessionStorage, SUBMIT_KEY);
    if (posted) {
      sRemove(sessionStorage, SUBMIT_KEY);
      sSet(localStorage, SUB_KEY, '1');
      document.querySelectorAll('.sl-plus-product-link').forEach(function (el) {
        el.hidden = true;
      });

      // Hide leftover Shopify form success copy (footer / newsletter) — toast is the signal
      document.querySelectorAll(
        '.footer .form__message--success, .newsletter .form__message--success, .popup .form__message--success'
      ).forEach(function (el) {
        el.hidden = true;
      });

      if (window.history && window.history.replaceState) {
        var clean = window.location.pathname + window.location.search;
        window.history.replaceState({}, '', clean);
      }
      window.scrollTo(0, 0);

      if (toast) {
        toast.hidden = false;
        setTimeout(function () { toast.hidden = true; }, 6500);
      }
    }

    if (!popup) return;

    function setSignupSource(source) {
      var note = popup.querySelector('input[name="contact[note]"]');
      if (note) note.value = source;
    }

    function openPopup() {
      popup.hidden = false;
      document.documentElement.classList.add('sl-plus-popup-open');
      var firstField = popup.querySelector('input[type="text"]');
      if (firstField) firstField.focus({ preventScroll: true });
    }

    function closePopup(dismissed) {
      popup.hidden = true;
      document.documentElement.classList.remove('sl-plus-popup-open');
      // Dismiss only suppresses buy-click popups for the rest of this session
      if (dismissed) sSet(sessionStorage, SESSION_DISMISS_KEY, '1');
    }

    function canShow() {
      if (sGet(localStorage, SUB_KEY)) return false;
      if (sGet(sessionStorage, SESSION_DISMISS_KEY)) return false;
      return true;
    }

    // Hide product CTA links once subscribed
    if (sGet(localStorage, SUB_KEY)) {
      document.querySelectorAll('.sl-plus-product-link').forEach(function (el) {
        el.hidden = true;
      });
    }

    if (!posted && wasSubmitting && popup.querySelector('[data-sl-plus-errors]')) {
      sRemove(sessionStorage, SUBMIT_KEY);
      openPopup();
    }

    // Close handlers
    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-sl-plus-close]')) closePopup(true);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) closePopup(true);
    });

    // Any SquareLocator+ form submitting anywhere marks submitting + subscribed
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && f.querySelector && f.querySelector('input[name="contact[tags]"][value*="squarelocator-plus"]')) {
        sSet(sessionStorage, SUBMIT_KEY, '1');
        sSet(localStorage, SUB_KEY, '1');
        document.querySelectorAll('.sl-plus-product-link').forEach(function (el) {
          el.hidden = true;
        });
      }
    }, true);

    // Soft product-page link: open popup immediately (bypasses dismiss/session suppress)
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-sl-plus-open]');
      if (trigger) {
        e.preventDefault();
        if (sGet(localStorage, SUB_KEY)) return;
        setSignupSource('signup_source:product-cta-link');
        openPopup();
        return;
      }

      // Affiliate buy click: vendor tab opens untouched, popup appears in this tab
      var link = e.target.closest('a.product-form__submit[target="_blank"]');
      if (!link) return;
      if (!canShow()) return;
      setSignupSource('signup_source:post-click-popup');
      setTimeout(openPopup, 700);
    });
  });
})();
